import { isValidLocale } from '../locale-validation'
import type { Locale } from '../types/locale'

export const getLocaleFromPathname = (pathname: string): Locale => {
  const locale = pathname.split('/').find(Boolean) ?? ''
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return locale
}
